import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioCatalogBundleEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioCatalogBundleEntity
